/** @import modules */

import { useTranslation }           from "react-i18next";

import { useContext, useEffect }    from "react";

import { Link }                     from "react-router-dom";

/** @import hooks */

import { CartContext }              from "../../../Contexts/CartContext";

/** @import components */

import Breadcrumbs                  from "../../../Components/Layout/Header/Breadcrumbs";

import CheckoutLayout               from "../../../Components/Orders/Checkout/Layout";

/** @import icons */

import { AiOutlineCheckCircle }     from "react-icons/ai";

import { BsFillCalendar2WeekFill }  from "react-icons/bs";

const TransactionSuccess = () => { const { t } = useTranslation (),

    { setCart } = useContext ( CartContext );

    useEffect ( () => { setCart ( [] ); }, [ setCart ] );

    /** @returns */

    return ( <div className="container max-content-width">

        <Breadcrumbs collection={ [

            { name: t ( "checkout" ), URI: "/orders/checkout" },

            { name: t ( "receipt_breadcrumb" ), URI: "#" }

        ] } type="basic" />

        <CheckoutLayout title={ t ( "checkout" ) }>

            <div className="receipt">

                <div className="title">
                    
                    <h2>

                        { t ( "order_thankyou" ) }

                    </h2>
                    
                </div>

                <div className="message success">

                    <div className="icon success">

                        <AiOutlineCheckCircle />

                    </div>
                    
                    <p>{ t ( "order_thankyou_message" ) }</p>
                    
                </div>

            </div>

        </CheckoutLayout>

        <div className="orders_montage">

            <div className="icon">

                <BsFillCalendar2WeekFill size={ 24 } />

            </div>

            <div className="description">

                { t ( "checkout_montage_notice" ) }

            </div>

            <Link to="/content/montage">

                { t ( "montage" ) }

            </Link>

        </div>
        
    </div> );

}

/** @exports TransactionSuccess */
 
export default TransactionSuccess;